import type { CollapseProps } from "antd";
import GeneralInfo from "./Info";
import ForceUpdateSettings from "./ForceUpdateSettings";

export const InputStyle = { 
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};

export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "120px",
	fontSize: "15px",
};

export const panelStyle: React.CSSProperties = {
	border: "none",
};

export const EditMobileAppVersionConstants = {
	GENERAL_INFO: "Genel Bilgiler",
	FORCE_UPDATE: "Force Update Ayarları"
};

export const MobileAppVersionItems: CollapseProps["items"] = [
	{
		key: "1",
		label: EditMobileAppVersionConstants.GENERAL_INFO,
		children: <GeneralInfo />,
		style: panelStyle,
	},	
	{
		key: "2",
		label: EditMobileAppVersionConstants.FORCE_UPDATE,
		children: <ForceUpdateSettings />,
		style: panelStyle,
	},
];
